import * as R from 'ramda';
import React from 'react';

import styles from 'iss/styles/TextArea.styl';
import BootstrapFormGroup from 'iss/widgets/bootstrap/FormGroup';

export function BootstrapTextArea(props) {
  const inputProps = R.pick(['placeholder', 'onChange', 'id', 'rows', 'columns', 'maxLength', 'disabled'], props);
  inputProps.value = R.defaultTo('', props.value);

  return <BootstrapFormGroup {...props}>
    <textarea className="form-control" {...inputProps}>{inputProps.value}</textarea>
    {props.error ? <span className="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"></span> : null}
    {props.showCounter ? <span className={styles.counterText}>{length(props.value) + " / " + inputProps.maxLength}</span> : null}
  </BootstrapFormGroup>;
}

export default BootstrapTextArea;

function length(value) {
  return value == null ? 0 : value.length;
}


// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/TextArea.jsx